import { useState, useEffect, useContext } from "react";
import { Input } from "design-react-kit";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import Select from "../../Components/Select";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import LabelsLoader from "../../Utility/labelsLoader";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import CustomInput from "../../Components/CustomInput";

function Configuration(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const labels = LabelsLoader();
  useEffect(() => {
    setLoading(false);
    Repo.getConfiguration(apiToken)
      .then((response) => {
        setData(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const validateConfiguration = () => {
    setValidation(true);
    let passedValidation = true;

    Object.entries(data).map(([key, value]) => {
      //isArray is used to exclude the isees array in the validation
      if (value === "") {
        passedValidation = false;
      }
    });

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const updateConfiguration = () => {
    console.log(data);
    Repo.postUpdateConfiguration(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/configurazione";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <h1>Configurazione</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>{labels.configurazioneDescrizione} </p>
      </div>

      <div className="row mt-2 text-right">
        <div className="col-lg-12 clearfix">
          <svg className="icon icon-primary">
            <use href={`${iconSprite}#it-pencil`}></use>
          </svg>
          <span>
            {" "}
            <a
              className="text-decoration-none"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setIsDisabled(!isDisabled);
              }}
            >
              Modifica
            </a>
          </span>
        </div>
      </div>

      <div className="row mt-3">
        <div className="form-group col-md-4">
          <Input
            id="nomeComune"
            disabled={isDisabled}
            label="Nome Comune*"
            type="text"
            name="nomeComune"
            value={data ? data.nomeComune : ""}
            {...(validation &&
              !data.nomeComune && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, nomeComune: e.target.value })}
          />
        </div>

        <div className="form-group col-md-12">
          <Input
            id="footerComune"
            disabled={isDisabled}
            label="Footer Comune*"
            type="text"
            name="footerComune"
            value={data ? data.footerComune : ""}
            {...(validation &&
              !data.footerComune && {
                infoText: "Il campo non può essere vuoto!",
                className: "text-danger error_div is-invalid",
              })}
            onChange={(e) => setData({ ...data, footerComune: e.target.value })}
          />
        </div>

        <div className="col-right text-right">
          {!isDisabled ? (
            <span>
              <button
                type="button"
                className="btn btn-outline-secondary m-2"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setIsDisabled(!isDisabled)}
                title="Indietro"
              >
                Indietro
              </button>

              <button
                type="button"
                className="btn btn-outline-primary"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => validateConfiguration()}
                title="Conferma"
              >
                Conferma
              </button>
            </span>
          ) : null}
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modifica configurazione"
        body="Confermi di voler modificare la configurazione dell'applicativo?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => updateConfiguration()}
      ></ModalComponent>

      {!loading && <Loader></Loader>}
    </div>
  );
}

export default Configuration;
